export default "__VITE_ASSET__WoxnOGdz__"